import { IconName } from '@/common/components/Icon/iconName';
import { ShareActionType } from '@/forwarding/constants/ShareActionType';

export function getShareActionIcon(type: ShareActionType): IconName {
  switch (type) {
    case ShareActionType.WhatsApp:
      return 'whatsapp';
    case ShareActionType.AddToSpectrum:
      return 'metrics-color-material';
    case ShareActionType.CopyLink:
      return 'link';
    case ShareActionType.CopyLinkWithInfo:
      return 'link-info';
    case ShareActionType.Email:
      return 'email';
    case ShareActionType.QrCode:
      return 'qr';
    case ShareActionType.Facebook:
      return 'facebook';
    case ShareActionType.Twitter:
      return 'x-twitter';
    case ShareActionType.Pinterest:
      return 'pinterest';
    case ShareActionType.NativeShare:
      return 'more';
  }
}
